// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/store';

// Custom added
import VeeValidate from 'vee-validate';
import VueSweetalert2 from 'vue-sweetalert2';
import BootstrapVue from 'bootstrap-vue';

//jQuery and bootstrap, blockui
window.$ = window.jQuery = require('jquery');
import 'bootstrap';

import '@/assets/css/theme.min.css';

if (store.state.navState == 'backend') {
  var bootstrapVue = require('bootstrap-vue/dist/bootstrap-vue.css');
}

var AppCss = require('@/assets/scss/app.scss');

var blockUI = require('@/assets/js/blockui.js');
var cube = require('@/assets/js/jquery.cubeportfolio.min.js');
var owlCarousel = require('@/assets/js/owl.carousel.min.js');

Vue.use(BootstrapVue);
Vue.use(VeeValidate);
Vue.use(VueSweetalert2);

global.APIURL = 'http://molawconsult.com/apiweb/';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js